import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Re-extract Staged Sales Order Input Schema
 */
export const ReextractSalesOrderDraftInputSchema = z.object({
  inboundEmailId: z.uuid(),
  classificationId: z.uuid().optional(),
  userContextNoteMarkdown: z.string().optional(),
  refreshOCR: z.boolean().prefault(false),
});

/**
 * Re-extract Staged Sales Order Response Schema
 */
export const ReextractSalesOrderDraftResponseSchema = z.object({
  success: z.boolean(),
  extractionResultId: z.uuid().optional(),
  status: z.enum(["success", "failed"]),
  error: z.string().optional(),
  userContextNote: z.string().optional(), // Echo back the user note for confirmation
});

/**
 * Accounts Receivable Contracts
 */
export const salesOrdersContracts = {
  // Re-extract purchase order with optional user context
  reExtract: oc
    .input(ReextractSalesOrderDraftInputSchema)
    .output(ReextractSalesOrderDraftResponseSchema)
    .route({
      method: "POST",
    }),
} as const;

// Export types
export type ReextractSalesOrderDraftInput = z.infer<
  typeof ReextractSalesOrderDraftInputSchema
>;
export type ReextractSalesOrderDraftResponse = z.infer<
  typeof ReextractSalesOrderDraftResponseSchema
>;
